export const SET_CONTRIES_VISUALIZATION = 'SET_CONTRIES_VISUALIZATION';
export const SET_DATA_VISUALIZATION = 'SET_DATA_VISUALIZATION'
export const SET_DATA_CONSENSUS_VARIABLE = 'SET_DATA_CONSENSUS_VARIABLE'